module.exports = __webpack_public_path__ + "static/rough-0d3507bee1f4633054fb3164d05b9076.jpg";